import React, { VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { RegionCityPageCard } from '../pages/Top';
import { TEXT_SECONDARY } from '../../core/styles/variables';
import {
  HomeMediaCard,
  LabelPill,
  HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP,
} from '../components/home/cards';

type Props = RegionCityPageCard & {
  className?: string;
};

const CITY_NAME_CLASS = 'region-city-card-cityName';

const Card: VFC<Props> = ({
  id,
  prefectureName,
  cityName,
  cityNameHirakana,
  description,
  coverImageUrl,
  className,
}) => {
  const classes = useStyles();
  return (
    <HomeMediaCard
      href={`/cities/${id}`}
      className={clsx(classes.cardRoot, className)}
      elevated
      mediaAspectPaddingTop={HOME_MEDIA_DEFAULT_MEDIA_PADDING_TOP}
      imageUrl={coverImageUrl}
      imageAlt={cityName}
      topLeft={<LabelPill label={prefectureName} />}
    >
      <div className={classes.body}>
        <div className={classes.titleBlock}>
          <div className={classes.nameBlock}>
            <span className={classes.furigana}>{cityNameHirakana}</span>
            <span className={clsx(classes.cityName, CITY_NAME_CLASS)}>
              {cityName}
            </span>
          </div>
        </div>
        <div className={classes.descWrap}>
          <span className={classes.description}>{description}</span>
        </div>
      </div>
    </HomeMediaCard>
  );
};

export default Card;

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    color: '#333',
    '& .MuiCardActionArea-root:hover': {
      opacity: 1,
    },
    [`&:hover .${CITY_NAME_CLASS}`]: {
      textDecoration: 'underline',
      color: theme.palette.text.primary,
      textDecorationColor: theme.palette.text.primary,
    },
  },
  body: {
    display: 'flex',
    minHeight: 0,
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  titleBlock: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  nameBlock: {
    position: 'relative',
    flex: 1,
    minWidth: 0,
    textAlign: 'left',
    alignSelf: 'flex-end',
  },
  furigana: {
    position: 'absolute',
    left: 0,
    top: -12,
    minWidth: 0,
    textAlign: 'left',
    fontSize: theme.typography.pxToRem(10),
    color: TEXT_SECONDARY,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  cityName: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical' as const,
    overflow: 'hidden',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  descWrap: {
    display: 'flex',
    flex: 1,
    alignContent: 'flex-end',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontSize: theme.typography.pxToRem(12),
    color: TEXT_SECONDARY,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  description: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical' as const,
    overflow: 'hidden',
  },
}));
